<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Traffic Trends</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
          data-animation="false"
          title="This report illustrates the most common user journeys from app to app. It leverages
                          shared users to not only connect apps together but also to create relationships between a series of apps.">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a> <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-ctv-traffic-overlap [data]="data" [device]="device" [isFreemium]="isFreemium" [region]="region"
        [isFollowing]="isFollowing"></app-ctv-traffic-overlap>
    </div>
  </div>
</div>
